import { Badge } from '@material-ui/core';
import { LoanCriteria, SinglePaymentCriteria } from '@nemuru-eng/js-api-client';

import { GridDateTime } from '@/components/modules/_shared/utils/DataGridFields/GridDateTime';
import { Text } from '@/components/shared/components/Text';

export const updatedAtFieldColumn = ({ flex, sortable = true }: { flex?: number; sortable?: boolean }) => {
  return {
    flex: flex ?? 0.5,
    field: 'updated_at',
    headerName: <Text tId={'UPDATE_DATE'} />,
    align: 'right',
    type: 'number',
    sortable,
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData: { row: SinglePaymentCriteria | LoanCriteria }) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'column',
            lineHeight: 1.43,
            width: '100%',
          }}
        >
          {'hasNotifications' in rowData.row && rowData.row.hasNotifications && (
            <Badge color="primary" badgeContent="" variant="dot">
              <i className="material-icons-outlined mr-3">notifications</i>
            </Badge>
          )}
          <GridDateTime value={rowData.row.updatedAt} />
        </div>
      );
    },
  };
};
